import {
  SET_MAP_LOADED,
  SET_VIDEO_LOADED,
  SET_HERO_ANIMATION,
  SET_PLACE_PICKER_LOADED
} from '@/store/mutation-types'

const state = {
  isAnimationComplete: false,
  isMapLoading: true,
  isVideoLoading: true,
  isContestMapLoading: true
}

const getters = {
  isLoading (state) {
    return state.isMapLoading || state.isVideoLoading || state.isContestMapLoading
  }
}

const mutations = {
  [SET_MAP_LOADED] (state) {
    state.isMapLoading = false
  },
  [SET_VIDEO_LOADED] (state) {
    state.isVideoLoading = false
  },
  [SET_HERO_ANIMATION] (state) {
    state.isAnimationComplete = true
  },
  [SET_PLACE_PICKER_LOADED] (state) {
    state.isContestMapLoading = false
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/main.js